import { ChangeEvent, InputHTMLAttributes, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const middleAlign = {
    verticalAlign: 'middle',
};

export type Props = {
    id: string;
    className?: string;
    required?: boolean;
    label?: string;
    labelKey?: string;
    input: InputHTMLAttributes<HTMLInputElement> & any;
    disabled?: boolean;
    readOnly?: boolean;
};

export const CheckField = ({ required, id, className = '', input, label, labelKey, disabled = false, readOnly = false }: Props) => {
    const { t } = useTranslation();

    const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        // Chrome ignores the 'readonly' attribute on checkbox input.
        // So, manually bail out if we're supposed to be read only.
        if (readOnly) {
            return false;
        }
        input.onChange && input.onChange(e);
    }, [ readOnly, input.onChange ]);

    return (
        <div
            id={ id ? `${id}-field` : undefined }
            className={ `${required ? 'required' : ''} ui checkbox field check-field ${className}` }
            style={ middleAlign }
        >
            <input
                id={ id }
                type="checkbox"
                checked={ input.value }
                { ...input }
                disabled={ disabled || false }
                readOnly={ readOnly }
                onChange={ handleChange }
            />

            <label
                htmlFor={ id }
                className={ disabled ? 'disabled' : '' }
                style={ { paddingLeft: '2em' } }
            >
                { label || t(labelKey!) }
            </label>
        </div>
    );
};
